/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * NEXMAIL (Internal)
 * Internal API consumed by the nexmail dashboard.
 * OpenAPI spec version: 0.0.1
 */

export type EmailDocumentSectionResponseDtoCategory =
  (typeof EmailDocumentSectionResponseDtoCategory)[keyof typeof EmailDocumentSectionResponseDtoCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmailDocumentSectionResponseDtoCategory = {
  header: 'header',
  hero: 'hero',
  banner: 'banner',
  content: 'content',
  cta: 'cta',
  product: 'product',
  image: 'image',
  footer: 'footer',
} as const;
